import { defaultColor, formControlFontSizeStyles } from '../formControlStyles';
import { fontWeights } from "../../../tokens/typography";
import { colors } from "../../../tokens/color";
import { shadows } from "../../../tokens/shadow";
export const tooltipLabelStyles = {
    labelContainer: {
        display: 'flex',
        alignItems: 'center',
        ...formControlFontSizeStyles,
    },
    label: (labelColor = defaultColor, weight = 'medium') => ({
        color: labelColor,
        fontSize: 'inherit',
        fontWeight: fontWeights[weight],
    }),
    tooltipButton: {
        marginLeft: '1rem',
        display: 'flex',
    },
    tooltipIcon: (labelColor = defaultColor) => ({
        height: '1em',
        width: '1em',
        '& path': {
            fill: labelColor,
        },
        verticalAlign: 'text-top',
    }),
    tooltip: {
        fontSize: '1.4rem',
        border: `1px solid ${colors.core.smoke}`,
        color: colors.core.blackTarr,
        backgroundColor: colors.core.snow,
        boxShadow: shadows.soft,
        zIndex: 5000,
    },
};
